import featureTextCarousel from './feature-text-carousel';
export default featureTextCarousel;
